(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[16626],{

/***/ 11334:
/***/ (function() {

// focus - focusOptions - preventScroll polyfill
(function() {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined" ||
    typeof HTMLElement === "undefined"
  ) {
    return;
  }

  var supportsPreventScrollOption = false;
  try {
    var focusElem = document.createElement("div");
    focusElem.addEventListener(
      "focus",
      function(event) {
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
    focusElem.focus(
      Object.defineProperty({}, "preventScroll", {
        get: function() {
          // Edge v18 gives a false positive for supporting inputs
          if (
            navigator &&
            typeof navigator.userAgent !== 'undefined' &&
            navigator.userAgent &&
            navigator.userAgent.match(/Edge\/1[7-8]/)) {
              return supportsPreventScrollOption = false
          }

          supportsPreventScrollOption = true;
        }
      })
    );
  } catch (e) {}

  if (
    HTMLElement.prototype.nativeFocus === undefined &&
    !supportsPreventScrollOption
  ) {
    HTMLElement.prototype.nativeFocus = HTMLElement.prototype.focus;

    var calcScrollableElements = function(element) {
      var parent = element.parentNode;
      var scrollableElements = [];
      var rootScrollingElement =
        document.scrollingElement || document.documentElement;

      while (parent && parent !== rootScrollingElement) {
        if (
          parent.offsetHeight < parent.scrollHeight ||
          parent.offsetWidth < parent.scrollWidth
        ) {
          scrollableElements.push([
            parent,
            parent.scrollTop,
            parent.scrollLeft
          ]);
        }
        parent = parent.parentNode;
      }
      parent = rootScrollingElement;
      scrollableElements.push([parent, parent.scrollTop, parent.scrollLeft]);

      return scrollableElements;
    };

    var restoreScrollPosition = function(scrollableElements) {
      for (var i = 0; i < scrollableElements.length; i++) {
        scrollableElements[i][0].scrollTop = scrollableElements[i][1];
        scrollableElements[i][0].scrollLeft = scrollableElements[i][2];
      }
      scrollableElements = [];
    };

    var patchedFocus = function(args) {
      if (args && args.preventScroll) {
        var evScrollableElements = calcScrollableElements(this);
        this.nativeFocus();
        if (typeof setTimeout === 'function') {
          setTimeout(function () {
            restoreScrollPosition(evScrollableElements);
          }, 0);
        } else {
          restoreScrollPosition(evScrollableElements);          
        }
      }
      else {
        this.nativeFocus();
      }
    };

    HTMLElement.prototype.focus = patchedFocus;
  }
})();


/***/ }),

/***/ 16626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Animated_ImageZoom; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./node_modules/focus-options-polyfill/index.js
var focus_options_polyfill = __webpack_require__(11334);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/react-medium-image-zoom/dist/esm/helpers.js


var toDurationString = function (duration) { return "".concat(duration, "ms"); };
var getScale = function (_a) {
    var height = _a.height, innerHeight = _a.innerHeight, innerWidth = _a.innerWidth, width = _a.width, zoomMargin = _a.zoomMargin;
    var scaleX = innerWidth / (width + zoomMargin);
    var scaleY = innerHeight / (height + zoomMargin);
    var scale = Math.min(scaleX, scaleY);
    return scale;
};
var getModalContentStyle = function (_a) {
    var height = _a.height, innerHeight = _a.innerHeight, innerWidth = _a.innerWidth, isLoaded = _a.isLoaded, isUnloading = _a.isUnloading, left = _a.left, originalTransform = _a.originalTransform, top = _a.top, transitionDuration = _a.transitionDuration, width = _a.width, zoomMargin = _a.zoomMargin;
    var transitionDurationString = toDurationString(transitionDuration);
    if (!isLoaded || isUnloading) {
        var initTransform = (0,tslib_es6.__spreadArray)([
            'scale(1)',
            'translate(0, 0)'
        ], (originalTransform ? [originalTransform] : []), true).join(' ');
        return {
            height: height,
            left: left,
            top: top,
            transform: initTransform,
            WebkitTransform: initTransform,
            transitionDuration: transitionDurationString,
            width: width,
        };
    }
    // Get amount to scale item
    var scale = getScale({
        height: height,
        innerWidth: innerWidth,
        innerHeight: innerHeight,
        width: width,
        zoomMargin: zoomMargin,
    });
    // Get the the coords for center of the viewport
    var viewportX = innerWidth / 2;
    var viewportY = innerHeight / 2;
    // Get the coords for center of the parent item
    var childCenterX = left + width / 2;
    var childCenterY = top + height / 2;
    // Get offset amounts for item coords to be centered on screen
    var translateX = (viewportX - childCenterX) / scale;
    var translateY = (viewportY - childCenterY) / scale;
    // Build transform style, including any original transform
    var transform = (0,tslib_es6.__spreadArray)([
        "scale(".concat(scale, ")"),
        "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    ], (originalTransform ? [originalTransform] : []), true).join(' ');
    return {
        height: height,
        left: left,
        top: top,
        transform: transform,
        WebkitTransform: transform,
        transitionDuration: transitionDurationString,
        width: width,
    };
};
var getModalOverlayStyle = function (_a) {
    var isLoaded = _a.isLoaded, isUnloading = _a.isUnloading, overlayBgColorEnd = _a.overlayBgColorEnd, overlayBgColorStart = _a.overlayBgColorStart, transitionDuration = _a.transitionDuration, zoomZindex = _a.zoomZindex;
    var style = {
        backgroundColor: overlayBgColorStart,
        transitionDuration: toDurationString(transitionDuration),
        zIndex: zoomZindex,
    };
    if (isLoaded && !isUnloading) {
        style.backgroundColor = overlayBgColorEnd;
    }
    return style;
};
var pseudoParentEl = {
    getBoundingClientRect: function () { return ({
        height: 0,
        left: 0,
        top: 0,
        width: 0,
    }); },
    style: {
        transform: null,
    },
};



;// CONCATENATED MODULE: ./node_modules/react-medium-image-zoom/dist/esm/Controlled-f6e8a5ed.js





// https://github.com/streamich/react-use/blob/master/src/useEffectOnce.ts
var useEffectOnce = function (effect) {
    (0,react.useEffect)(effect, []); // eslint-disable-line
};

// https://github.com/streamich/react-use/blob/master/src/useUnmount.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useUnmount = function (fn) {
    var fnRef = (0,react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    useEffectOnce(function () { return function () { return fnRef.current(); }; });
};

// https://github.com/streamich/react-use/blob/master/src/useRafState.ts
var useRafState = function (initialState) {
    var frame = (0,react.useRef)(0);
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0,react.useCallback)(function (value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function () {
            setState(value);
        });
    }, []);
    useUnmount(function () {
        cancelAnimationFrame(frame.current);
    });
    return [state, setRafState];
};

// https://github.com/streamich/react-use/blob/master/src/useWindowSize.ts
var useWindowSize = function (initialWidth, initialHeight) {
    if (initialWidth === void 0) { initialWidth = Infinity; }
    if (initialHeight === void 0) { initialHeight = Infinity; }
    var isBrowser = typeof window !== 'undefined';
    var _a = useRafState({
        width: isBrowser ? window.innerWidth : initialWidth,
        height: isBrowser ? window.innerHeight : initialHeight,
    }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        if (isBrowser) {
            var handler_1 = function () {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };
            window.addEventListener('resize', handler_1);
            return function () {
                window.removeEventListener('resize', handler_1);
            };
        }
    }, [isBrowser, setState]);
    return state;
};

// https://github.com/streamich/react-use/blob/master/src/usePrevious.ts
function usePrevious(state) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function () {
        ref.current = state;
    });
    return ref.current;
}

var ControlledActivated = function (_a) {
    var children = _a.children, _b = _a.closeText, closeText = _b === void 0 ? 'Unzoom Image' : _b, isActiveFromParent = _a.isActive, onLoad = _a.onLoad, onUnload = _a.onUnload, onZoomChange = _a.onZoomChange, _c = _a.overlayBgColorEnd, overlayBgColorEnd = _c === void 0 ? 'rgba(255, 255, 255, 0.95)' : _c, _d = _a.overlayBgColorStart, overlayBgColorStart = _d === void 0 ? 'rgba(255, 255, 255, 0)' : _d, parentRef = _a.parentRef, _e = _a.portalEl, portalEl = _e === void 0 ? document.body : _e, _f = _a.scrollableEl, scrollableEl = _f === void 0 ? window : _f, _g = _a.transitionDuration, transitionDuration = _g === void 0 ? 300 : _g, _h = _a.zoomMargin, zoomMargin = _h === void 0 ? 0 : _h, _j = _a.zoomZindex, zoomZindex = _j === void 0 ? 2147483647 : _j;
    var btnRef = (0,react.useRef)(null);
    var _k = (0,react.useState)(0), forceUpdate = _k[1];
    var _l = (0,react.useState)(isActiveFromParent), isActive = _l[0], setIsActive = _l[1];
    var _m = (0,react.useState)(false), isLoaded = _m[0], setIsLoaded = _m[1];
    var _o = (0,react.useState)(false), isUnloading = _o[0], setIsUnloading = _o[1];
    var prevIsActive = usePrevious(isActive);
    var prevIsActiveFromParent = usePrevious(isActiveFromParent);
    var prevIsLoaded = usePrevious(isLoaded);
    var _p = useWindowSize(), innerWidth = _p.width, innerHeight = _p.height;
    // on click, tell caller it should zoom
    var handleClick = (0,react.useCallback)(function (e) {
        e.preventDefault();
        if (onZoomChange) {
            onZoomChange(false);
        }
    }, [onZoomChange]);
    // on escape, tell caller it should unzoom
    var handleKeyDown = (0,react.useCallback)(function (e) {
        if (isActive && (e.key === 'Escape' || e.keyCode === 27)) {
            e.stopPropagation();
            if (onZoomChange) {
                onZoomChange(false);
            }
        }
    }, [isActive, onZoomChange]);
    var handleScroll = (0,react.useCallback)(function () {
        forceUpdate(function (n) { return n + 1; });
        if (!isUnloading && onZoomChange) {
            onZoomChange(false);
        }
    }, [isUnloading, onZoomChange]);
    // listen for keydown on the document
    (0,react.useEffect)(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
    // listen for scroll and close
    (0,react.useEffect)(function () {
        var _a;
        (_a = scrollableEl === null || scrollableEl === void 0 ? void 0 : scrollableEl.addEventListener) === null || _a === void 0 ? void 0 : _a.call(scrollableEl, 'scroll', handleScroll);
        return function () {
            var _a;
            (_a = scrollableEl === null || scrollableEl === void 0 ? void 0 : scrollableEl.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(scrollableEl, 'scroll', handleScroll);
        };
    }, [handleScroll, scrollableEl]);
    // set loaded on mount and focus
    (0,react.useEffect)(function () {
        if (!prevIsActive && isActive) {
            setIsLoaded(true);
            if (btnRef.current) {
                btnRef.current.focus({ preventScroll: true });
            }
        }
    }, [isActive, prevIsActive]);
    (0,react.useEffect)(function () {
        // when parent says to deactivate, begin unloading process
        if (prevIsActiveFromParent && !isActiveFromParent) {
            setIsUnloading(true);
        }
        // when parent says to activate, begin active process
        if (!prevIsActiveFromParent && isActiveFromParent) {
            setIsActive(true);
        }
    }, [isActiveFromParent, prevIsActiveFromParent]);
    // if unloading, tell parent that we're all done here after Nms
    (0,react.useEffect)(function () {
        var unloadTimeout;
        if (isUnloading) {
            unloadTimeout = setTimeout(function () {
                setIsLoaded(false);
                setIsActive(false);
                setIsUnloading(false);
            }, transitionDuration);
        }
        return function () {
            clearTimeout(unloadTimeout);
        };
    }, [isUnloading, transitionDuration]);
    // let parent know of changes to load status
    (0,react.useEffect)(function () {
        if (!prevIsLoaded && isLoaded) {
            onLoad();
        }
        if (prevIsLoaded && !isLoaded) {
            onUnload();
        }
    }, [isLoaded, onLoad, onUnload, prevIsLoaded]);
    // use parent element or fake one if it's not yet loaded
    var parentEl = parentRef.current || pseudoParentEl;
    // get parent element's dimensions
    var _q = parentEl.getBoundingClientRect(), height = _q.height, left = _q.left, top = _q.top, width = _q.width;
    var overlayStyle = getModalOverlayStyle({
        isLoaded: isLoaded,
        isUnloading: isUnloading,
        overlayBgColorEnd: overlayBgColorEnd,
        overlayBgColorStart: overlayBgColorStart,
        transitionDuration: transitionDuration,
        zoomZindex: zoomZindex,
    });
    var contentStyle = getModalContentStyle({
        height: height,
        isLoaded: isLoaded,
        innerHeight: innerHeight,
        innerWidth: innerWidth,
        isUnloading: isUnloading,
        left: left,
        originalTransform: parentEl.style.transform,
        top: top,
        transitionDuration: transitionDuration,
        width: width,
        zoomMargin: zoomMargin,
    });
    return isActive
        ? (0,react_dom.createPortal)(react.createElement("div", { "aria-label": "Zoomed image", "aria-modal": true, "data-rmiz-overlay": true, role: "dialog", style: overlayStyle },
            react.createElement("div", { "data-rmiz-modal-content": true, style: contentStyle }, children),
            react.createElement("button", { "aria-label": closeText, "data-rmiz-btn-close": true, onClick: handleClick, ref: btnRef, type: "button" })), portalEl)
        : null;
};
var ControlledActivated$1 = (0,react.memo)(ControlledActivated);

var Controlled = function (_a) {
    var children = _a.children, _b = _a.closeText, closeText = _b === void 0 ? 'Unzoom image' : _b, isActive = _a.isZoomed, _c = _a.overlayBgColorEnd, overlayBgColorEnd = _c === void 0 ? 'rgba(255, 255, 255, 0.95)' : _c, _d = _a.overlayBgColorStart, overlayBgColorStart = _d === void 0 ? 'rgba(255, 255, 255, 0)' : _d, portalEl = _a.portalEl, onZoomChange = _a.onZoomChange, _e = _a.openText, openText = _e === void 0 ? 'Zoom image' : _e, scrollableEl = _a.scrollableEl, _f = _a.transitionDuration, transitionDuration = _f === void 0 ? 300 : _f, _g = _a.wrapElement, WrapElement = _g === void 0 ? 'div' : _g, wrapStyle = _a.wrapStyle, _h = _a.zoomMargin, zoomMargin = _h === void 0 ? 0 : _h, _j = _a.zoomZindex, zoomZindex = _j === void 0 ? 2147483647 : _j;
    var _k = (0,react.useState)(false), isChildLoaded = _k[0], setIsChildLoaded = _k[1];
    var wrapRef = (0,react.useRef)(null);
    var btnRef = (0,react.useRef)(null);
    var handleClickTrigger = (0,react.useCallback)(function (e) {
        if (!isActive && onZoomChange) {
            e.preventDefault();
            onZoomChange(true);
        }
    }, [isActive, onZoomChange]);
    var handleChildLoad = (0,react.useCallback)(function () {
        setIsChildLoaded(true);
    }, []);
    var handleChildUnload = (0,react.useCallback)(function () {
        setIsChildLoaded(false);
        if (btnRef.current) {
            btnRef.current.focus({ preventScroll: true });
        }
    }, []);
    var wrapType = isChildLoaded ? 'hidden' : 'visible';
    return (react.createElement(react.StrictMode, null,
        react.createElement(WrapElement, { "data-rmiz-wrap": wrapType, ref: wrapRef, style: wrapStyle },
            children,
            react.createElement("button", { "aria-label": openText, "data-rmiz-btn-open": true, onClick: handleClickTrigger, ref: btnRef, type: "button" }),
            typeof window !== 'undefined' && (react.createElement(ControlledActivated$1, { closeText: closeText, isActive: isActive, onLoad: handleChildLoad, onUnload: handleChildUnload, onZoomChange: onZoomChange, overlayBgColorEnd: overlayBgColorEnd, overlayBgColorStart: overlayBgColorStart, parentRef: wrapRef, portalEl: portalEl, scrollableEl: scrollableEl, transitionDuration: transitionDuration, zoomMargin: zoomMargin, zoomZindex: zoomZindex }, children)))));
};
var Controlled$1 = (0,react.memo)(Controlled);



;// CONCATENATED MODULE: ./node_modules/react-medium-image-zoom/dist/esm/index.js








var UncontrolledActivated = function (_a) {
    var children = _a.children, _b = _a.closeText, closeText = _b === void 0 ? 'Unzoom Image' : _b, onUnload = _a.onUnload, onLoad = _a.onLoad, _c = _a.overlayBgColorEnd, overlayBgColorEnd = _c === void 0 ? 'rgba(255, 255, 255, 0.95)' : _c, _d = _a.overlayBgColorStart, overlayBgColorStart = _d === void 0 ? 'rgba(255, 255, 255, 0)' : _d, parentRef = _a.parentRef, _e = _a.portalEl, portalEl = _e === void 0 ? document.body : _e, _f = _a.scrollableEl, scrollableEl = _f === void 0 ? window : _f, _g = _a.transitionDuration, transitionDuration = _g === void 0 ? 300 : _g, _h = _a.zoomMargin, zoomMargin = _h === void 0 ? 0 : _h, _j = _a.zoomZindex, zoomZindex = _j === void 0 ? 2147483647 : _j;
    var btnRef = (0,react.useRef)(null);
    var _k = (0,react.useState)(0), forceUpdate = _k[1];
    var _l = (0,react.useState)(false), isLoaded = _l[0], setIsLoaded = _l[1];
    var _m = (0,react.useState)(false), isUnloading = _m[0], setIsUnloading = _m[1];
    var _o = useWindowSize(), innerWidth = _o.width, innerHeight = _o.height;
    // on click, begin unloading
    var handleClick = (0,react.useCallback)(function (e) {
        e.preventDefault();
        setIsUnloading(true);
    }, []);
    // on escape, begin unloading
    var handleKeyDown = (0,react.useCallback)(function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            e.stopPropagation();
            setIsUnloading(true);
        }
    }, []);
    var handleScroll = (0,react.useCallback)(function () {
        forceUpdate(function (n) { return n + 1; });
        if (!isUnloading) {
            setIsUnloading(true);
        }
    }, [isUnloading]);
    // listen for keydown on the document
    (0,react.useEffect)(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
    // listen for scroll and close
    (0,react.useEffect)(function () {
        var _a;
        (_a = scrollableEl === null || scrollableEl === void 0 ? void 0 : scrollableEl.addEventListener) === null || _a === void 0 ? void 0 : _a.call(scrollableEl, 'scroll', handleScroll);
        return function () {
            var _a;
            (_a = scrollableEl === null || scrollableEl === void 0 ? void 0 : scrollableEl.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(scrollableEl, 'scroll', handleScroll);
        };
    }, [handleScroll, scrollableEl]);
    // set loaded on mount and focus
    (0,react.useEffect)(function () {
        setIsLoaded(true);
        onLoad();
        if (btnRef.current) {
            btnRef.current.focus({ preventScroll: true });
        }
    }, [onLoad]);
    // if unloading, tell parent that we're all done here after Nms
    (0,react.useEffect)(function () {
        var unloadTimeout = isUnloading
            ? setTimeout(onUnload, transitionDuration)
            : null;
        return function () {
            if (unloadTimeout) {
                clearTimeout(unloadTimeout);
            }
        };
    }, [isUnloading, onUnload, transitionDuration]);
    // use parent element or fake one if it's not yet loaded
    var parentEl = parentRef.current || pseudoParentEl;
    // get parent item's dimensions
    var _p = parentEl.getBoundingClientRect(), height = _p.height, left = _p.left, top = _p.top, width = _p.width;
    var overlayStyle = getModalOverlayStyle({
        isLoaded: isLoaded,
        isUnloading: isUnloading,
        overlayBgColorEnd: overlayBgColorEnd,
        overlayBgColorStart: overlayBgColorStart,
        transitionDuration: transitionDuration,
        zoomZindex: zoomZindex,
    });
    var contentStyle = getModalContentStyle({
        height: height,
        isLoaded: isLoaded,
        innerHeight: innerHeight,
        innerWidth: innerWidth,
        isUnloading: isUnloading,
        left: left,
        originalTransform: parentEl.style.transform,
        top: top,
        transitionDuration: transitionDuration,
        width: width,
        zoomMargin: zoomMargin,
    });
    return (0,react_dom.createPortal)(react.createElement("div", { "aria-label": "Zoomed image", "aria-modal": true, "data-rmiz-overlay": true, role: "dialog", style: overlayStyle },
        react.createElement("div", { "data-rmiz-modal-content": true, style: contentStyle }, children),
        react.createElement("button", { "aria-label": closeText, "data-rmiz-btn-close": true, onClick: handleClick, ref: btnRef })), portalEl);
};
var UncontrolledActivated$1 = (0,react.memo)(UncontrolledActivated);

var Uncontrolled = function (_a) {
    var children = _a.children, _b = _a.closeText, closeText = _b === void 0 ? 'Unzoom image' : _b, _c = _a.overlayBgColorEnd, overlayBgColorEnd = _c === void 0 ? 'rgba(255, 255, 255, 0.95)' : _c, _d = _a.overlayBgColorStart, overlayBgColorStart = _d === void 0 ? 'rgba(255, 255, 255, 0)' : _d, portalEl = _a.portalEl, _e = _a.openText, openText = _e === void 0 ? 'Zoom image' : _e, scrollableEl = _a.scrollableEl, _f = _a.transitionDuration, transitionDuration = _f === void 0 ? 300 : _f, _g = _a.wrapElement, WrapElement = _g === void 0 ? 'div' : _g, wrapStyle = _a.wrapStyle, _h = _a.zoomMargin, zoomMargin = _h === void 0 ? 0 : _h, _j = _a.zoomZindex, zoomZindex = _j === void 0 ? 2147483647 : _j;
    var _k = (0,react.useState)(false), isActive = _k[0], setIsActive = _k[1];
    var _l = (0,react.useState)(false), isChildLoaded = _l[0], setIsChildLoaded = _l[1];
    var wrapRef = (0,react.useRef)(null);
    var btnRef = (0,react.useRef)(null);
    var handleClickTrigger = (0,react.useCallback)(function (e) {
        if (!isActive) {
            e.preventDefault();
            setIsActive(true);
        }
    }, [isActive]);
    var handleChildLoad = (0,react.useCallback)(function () {
        setIsChildLoaded(true);
    }, []);
    var handleChildUnload = (0,react.useCallback)(function () {
        setIsActive(false);
        setIsChildLoaded(false);
        if (btnRef.current) {
            btnRef.current.focus({ preventScroll: true });
        }
    }, []);
    var isExpanded = isActive && isChildLoaded;
    var wrapType = isExpanded ? 'hidden' : 'visible';
    return (react.createElement(react.StrictMode, null,
        react.createElement(WrapElement, { "data-rmiz-wrap": wrapType, ref: wrapRef, style: wrapStyle },
            children,
            react.createElement("button", { "aria-label": openText, "data-rmiz-btn-open": true, onClick: handleClickTrigger, ref: btnRef }),
            typeof window !== 'undefined' && isActive && (react.createElement(UncontrolledActivated$1, { closeText: closeText, onLoad: handleChildLoad, onUnload: handleChildUnload, overlayBgColorEnd: overlayBgColorEnd, overlayBgColorStart: overlayBgColorStart, parentRef: wrapRef, portalEl: portalEl, scrollableEl: scrollableEl, transitionDuration: transitionDuration, zoomMargin: zoomMargin, zoomZindex: zoomZindex }, children)))));
};
var Uncontrolled$1 = (0,react.memo)(Uncontrolled);



// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./node_modules/react-medium-image-zoom/dist/styles.css
var styles = __webpack_require__(91597);
;// CONCATENATED MODULE: ./UI/containers/Animated/ImageZoom/index.jsx






var ImageZoom = function(param) {
    var children = param.children, overlayBgColorEnd = param.overlayBgColorEnd, transitionDuration = param.transitionDuration, zoomMargin = param.zoomMargin;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var isTabletResolutions = (0,es.useSelector)(layout/* selectIsTablet */.aT);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Uncontrolled$1, {
        overlayBgColorEnd: overlayBgColorEnd,
        transitionDuration: transitionDuration,
        zoomMargin: isMobileResolution && 20 || isTabletResolutions && 50 || zoomMargin,
        children: children
    });
};
ImageZoom.defaultProps = {
    overlayBgColorEnd: "rgba(255, 255, 255, 0.985)",
    transitionDuration: 300,
    zoomMargin: 200
};
ImageZoom.propTypes = {
    children: prop_types_default().instanceOf(Object).isRequired,
    overlayBgColorEnd: (prop_types_default()).string,
    transitionDuration: (prop_types_default()).number,
    zoomMargin: (prop_types_default()).number
};
/* harmony default export */ var Animated_ImageZoom = (ImageZoom);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 91597:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);